export const ROLE_HEADER = 'Role' as const
